import store from "@/store";
import { LOGIN_ROUTE, EMAIL_VERIFICATION_WALL_ROUTE } from "@/router/routes";
import { CLEAR_ERRORMSG } from "@/store/action-types";
import { resetLoaders } from "@/utils/loaders";
import { RouteLocationNormalized } from "vue-router";

/**
 * Auth-only guard: Requires authentication and email verification,
 * but does NOT check subscription status.
 *
 * Use this for pages that should be accessible even without an active subscription
 * (e.g., support page from subscription wall).
 */
export const ifNotAuthOnlyDeny = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: Function
) => {
  try {
    store.dispatch(CLEAR_ERRORMSG);
    resetLoaders();

    // Check if user is authenticated
    if (store.getters.sessionToken == null || store.getters.account.data == null) {
      return next({ name: LOGIN_ROUTE });
    }

    // Skip email verification check for impersonation sessions
    if (!store.getters.isImpersonating) {
      if (store.getters.account.data && !store.getters.account.data.isEmailVerified) {
        if (to.name !== EMAIL_VERIFICATION_WALL_ROUTE) {
          return next({ name: EMAIL_VERIFICATION_WALL_ROUTE });
        }
      }
    }

    return next();
  } catch (error) {
    console.error("Auth-only guard error:", error);
    return next({ name: LOGIN_ROUTE });
  }
};
